const autoNgTemplateLoaderTemplate1 = require('./serviceTasksDatatable.html');

angular.module('portainer.docker').component('serviceTasksDatatable', {
  templateUrl: autoNgTemplateLoaderTemplate1,
  controller: 'ServiceTasksDatatableController',
  bindings: {
    dataset: '<',
    serviceId: '<',
    tableKey: '@',
    orderBy: '@',
    reverseOrder: '<',
    nodes: '<',
    agentProxy: '<',
    textFilter: '=',
    showTaskLogsButton: '<',
  },
});
